"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APosAdDisplayUpdateInputSchema = exports.APosAdDisplayCreateInputSchema = exports.APosAdDisplaySchema = void 0;
const zod_1 = require("zod");
const timestamps_schema_1 = require("../../../common/timestamps.schema");
const id_schema_1 = require("../../../common/id.schema");
const enums_1 = require("./enums");
/**
 * Provision code format: MD-XXXX-XXXX where X is an uppercase alpha-numeric
 * character excluding the ambiguous glyphs O, 0, I, 1, L.
 */
const ProvisionCodeRegex = /^MD-[A-HJ-KMNP-Z2-9]{4}-[A-HJ-KMNP-Z2-9]{4}$/;
exports.APosAdDisplaySchema = zod_1.z.object({
    tenantId: id_schema_1.TenantIdSchema,
    displayId: id_schema_1.EntityIdSchema,
    locationId: id_schema_1.EntityIdSchema,
    name: zod_1.z.string().min(1).max(100),
    description: zod_1.z.string().max(500).optional(),
    provisionCode: zod_1.z.string().regex(ProvisionCodeRegex),
    status: enums_1.APosAdDisplayStatusSchema.default('pending'),
    // Ordered list of playlists to play in sequence on loop. Empty = no playlist assigned.
    // Legacy single-playlist field (activePlaylistId) is still read by handlers for
    // back-compat with displays provisioned before multi-playlist support.
    activePlaylistIds: zod_1.z.array(id_schema_1.EntityIdSchema).default([]),
    activePlaylistId: id_schema_1.EntityIdSchema.optional(),
    resolution: zod_1.z.enum(['1080p', '4k']).default('1080p'),
    orientation: zod_1.z.enum(['landscape', 'portrait']).default('landscape'),
    lastHeartbeat: zod_1.z.number().optional(),
    ipAddress: zod_1.z.string().optional(),
    userAgent: zod_1.z.string().optional(),
    appVersion: zod_1.z.string().optional(),
    activatedAt: zod_1.z.number().optional(),
    releasedAt: zod_1.z.number().optional(),
    createdBy: zod_1.z.string().min(1),
}).merge(timestamps_schema_1.TimestampsSchema);
/**
 * Create input — fields a super-admin supplies when provisioning a display.
 * Server sets: tenantId, displayId, provisionCode, status, createdBy, timestamps.
 */
exports.APosAdDisplayCreateInputSchema = zod_1.z.object({
    locationId: id_schema_1.EntityIdSchema,
    name: zod_1.z.string().min(1).max(100),
    description: zod_1.z.string().max(500).optional(),
    resolution: zod_1.z.enum(['1080p', '4k']).optional(),
    orientation: zod_1.z.enum(['landscape', 'portrait']).optional(),
});
/**
 * Update input — partial of fields a super-admin can patch on an existing display.
 */
exports.APosAdDisplayUpdateInputSchema = zod_1.z.object({
    name: zod_1.z.string().min(1).max(100).optional(),
    description: zod_1.z.string().max(500).optional(),
    locationId: id_schema_1.EntityIdSchema.optional(),
    activePlaylistIds: zod_1.z.array(id_schema_1.EntityIdSchema).optional(),
    activePlaylistId: id_schema_1.EntityIdSchema.optional(),
    resolution: zod_1.z.enum(['1080p', '4k']).optional(),
    orientation: zod_1.z.enum(['landscape', 'portrait']).optional(),
    status: enums_1.APosAdDisplayStatusSchema.optional(),
});
//# sourceMappingURL=ad-display.schema.js.map